import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'Redux/User/slice';
import { CustomTag } from 'Components/CustomTag/CustomTag';
import { ITextMessage, IDataMessage } from 'Shared/Types/chat';
import { capitalizeFirstLetter, formatDate } from 'Shared/Utils';
import styles from './MessageContainer.module.scss';

type MessageContainerProps = {
  isGroup?: boolean;
  message: ITextMessage | IDataMessage;
  children?: JSX.Element;
};

export const MessageContainer: React.FC<MessageContainerProps> = ({
  isGroup = false,
  message,
  children,
}) => {
  const currentUser = useSelector(selectCurrentUser);
  const isOutgoing =
    message.user_name ===
    `${currentUser?.first_name} ${currentUser?.last_name}`;

  return (
    <div
      className={`${styles.messageContainer} ${
        isOutgoing && styles.messageContainer_outgoing
      } ${isGroup && styles.messageContainer_group}`}
    >
      {isGroup && (
        <div
          className={`${styles.messageContainer__header} ${
            isOutgoing && styles.messageContainer_outgoing__header
          }`}
        >
          <span
            className={styles.messageContainer__header__name}
            title={`User name: ${message.user_name}`}
          >
            {message.user_name}
          </span>

          <CustomTag content={capitalizeFirstLetter(message.user_role)} />
        </div>
      )}

      {children}

      <span
        className={`${styles.messageContainer__time} ${
          isOutgoing && styles.messageContainer_outgoing__time
        }`}
      >
        {formatDate({
          date: message.timestamp,
          outputFormat: 'time',
          hour12: false,
        })}
      </span>
    </div>
  );
};
